export default __webpack_public_path__ + "static/media/hero-tools.00becf08.jpg";